import { Trophy } from "lucide-react";

interface RollerLabsLogoProps {
  variant?: "light" | "dark";
  size?: "sm" | "md" | "lg";
}

const RollerLabsLogo = ({ variant = "dark", size = "md" }: RollerLabsLogoProps) => {
  const sizes = {
    sm: "text-lg",
    md: "text-xl",
    lg: "text-2xl",
  };
  const iconSizes = { sm: 16, md: 20, lg: 24 };

  return (
    <div className="flex items-center gap-2">
      <div className="flex items-center justify-center rounded-lg bg-primary p-1.5">
        <Trophy size={iconSizes[size]} className="text-primary-foreground" />
      </div>
      <span className={`${sizes[size]} font-bold tracking-tight ${variant === "light" ? "text-tv-text" : "text-foreground"}`}>
        Leaderboards
      </span>
    </div>
  );
};

export default RollerLabsLogo;
